import { Modal } from '@doordash/component-modal'
import { Colors, Inset } from '@doordash/design-language'
import * as React from 'react'
import styled from 'styled-components'
import * as DA from '../../../typeModules/events'
import AdditionalDisclosuresDocument from './AdditionalDisclosuresDocument'
import AuthAndReleaseDocument from './AuthAndReleaseDocument'
import BackgroundCheckDisclosure from './BackgroundCheckDisclosure'

import t from './strings'
import { DocumentListCell, DocumentListCellWrapper } from './styles'

export enum DocumentTypes {
  AdditionalDisclosuresDocument,
  AuthAndReleaseDocument,
  BackgroundCheckDisclosure,
}

type DocumentAcceptanceModalProps = {
  showModal?: boolean
  type: DocumentTypes | string
  anchorId?: string
  trackBackgroundCheckSteps?: (data: DA.TrackBackgroundCheck) => Promise<void>
}

type DocumentState = {
  showModal: boolean
  title: string
  content: React.ReactNode
}

const LegalModalDocumentStyle = styled.div`
  background-color: ${Colors.PageBackgroundSecondary};
  overflow-y: scroll;
  border: 1px solid ${Colors.BorderSecondary};
  border-radius: 4px;
`

export class DocumentAcceptanceModal extends React.Component<
  DocumentAcceptanceModalProps
> {
  public state: DocumentState = {
    showModal: false,
    title: '',
    content: null,
  }

  public constructor(props) {
    super(props)
    let { type } = props

    if (typeof type == 'string') {
      type = DocumentTypes[props.type]
    }
    switch (type) {
      case DocumentTypes.BackgroundCheckDisclosure:
        this.state.title = t.backgroundCheckDisclosureTitle()
        this.state.content = <BackgroundCheckDisclosure />
        break
      case DocumentTypes.AdditionalDisclosuresDocument:
        this.state.title = t.additionalDisclosuresTitle()
        this.state.content = <AdditionalDisclosuresDocument />
        break
      case DocumentTypes.AuthAndReleaseDocument:
        this.state.title = t.authAndReleaseDocumentTitle()
        this.state.content = <AuthAndReleaseDocument />
        break
      default:
        this.state.title = t.additionalDisclosuresTitle()
        this.state.content = <AdditionalDisclosuresDocument />
        break
    }
  }

  public render() {
    const { anchorId, trackBackgroundCheckSteps } = this.props
    const { title, content, showModal } = this.state
    return (
      <DocumentListCellWrapper data-anchor-id={anchorId}>
        <DocumentListCell
          title={title}
          onClick={e => {
            this.setState({
              showModal: true,
            })
            trackBackgroundCheckSteps({
              action: DA.EventActions.Clicked,
              page: DA.BackgroundCheckPages.Disclosures,
              value: title,
            })
            e.preventDefault()
          }}
        />
        {showModal && (
          <Modal
            onClose={() => {
              trackBackgroundCheckSteps({
                action: DA.EventActions.Close,
                page: DA.BackgroundCheckPages.Disclosures,
                value: title,
              })
              this.setState({
                showModal: false,
              })
            }}
            title={title}
            size={Modal.Sizes.Large}
            hasContentPadding
            ariaHideApp={false}
          >
            <LegalModalDocumentStyle>
              <Inset>{content}</Inset>
            </LegalModalDocumentStyle>
          </Modal>
        )}
      </DocumentListCellWrapper>
    )
  }
}

export default DocumentAcceptanceModal
